import { FINANCE_API } from '@/modules/banking/constants'
import lang from '@/lang'

const { ASSIGNMENT_STATE: { FULLY_ASSIGNED, PARTIALLY_ASSIGNED, NOT_ASSIGNED } } = FINANCE_API

export const getAssignmentState = (state) => {
  switch (state) {
    case FULLY_ASSIGNED:
      return lang.booking.assignmentStates.fullyAssigned
    case PARTIALLY_ASSIGNED:
      return lang.booking.assignmentStates.partiallyAssigned
    case NOT_ASSIGNED:
      return lang.booking.assignmentStates.notAssigned
    default:
      return ''
  }
}
